module.exports = "/_next/static/chunks/images/story-background-gray-afd423024c32a01d5773845bcbbfc103.svg";